Vue.component("Stream", {
    mixins: [SceneContentComponentMixin],
    template: `
        <transition enter-active-class="fadeIn" leave-active-class="fadeOut">
            <div class="Stream__wrapper" v-if="dimLights" @click="test">
                <transition name="fadeIn" enter-active-class="fadeIn">
                    <!-- <iframe v-if="videoplayerready" :src="link" frameborder="0" controls="0" autoplay="1" allow="autoplay; encrypted-media;" allowfullscreen></iframe> -->
                    <div class="Stream__innerWrapper">
                         <div class="lds-dual-ring"></div>
                       
                       <!-- 
                        <iframe src="//live.industrienshus.dk/v.ihtml/player.html?token=6e35ea6978d7bdb51c84&live%5fid=63134840&source=embed" 
                            style="" 
                            frameborder="0" 
                            border="0" 
                            scrolling="no" 
                            mozallowfullscreen="1" 
                            webkitallowfullscreen="1" 
                            allowfullscreen="1" 
                            allow="autoplay; fullscreen">
                        </iframe>
                        -->

                        <video src="assets/video/di-digital-full.mp4" controls autoplay playsinline style="    width: 100%; position: absolute; top: 0; left: 0;"/>
                    </div>
                </transition>
            </div>
        </transition>
    `,
    data() {
        return {
            link: '',

            // Variables for this instance to handle functionality
            videoplayerready: false,
            dimLights: false
        }
    },
    methods: {
        test() { 
            console.log("test")
        }
    },
    mounted() {
        this.dimLights = true;

        app.radio.$on("component-close", (id) => {
            console.log("Component closed", id)
        })

        setTimeout(() => {
            this.videoplayerready = true;
        }, 800);
    }
})

touchKit.ComponentManager.register("Stream", {
    singleton: true
});